export const SEARCH_TYPES = {
  TYPE: 'type',
  BRAND: 'brand',
  SUBTYPE: 'subtype',
  CLASSIFICATION: 'classification',
  GENERAL: 'general',
  EFFECT: 'effect',
  FLAVOR: 'flavor',
  PRODUCT: 'product',
  COLLECTION: 'collection'
};



// WEBPACK FOOTER //
// ./src/const/searchTypes.js